export const enum TravelerEditMode {
  FLIGHTS_ONLY = "FLIGHTS_ONLY",
  CARS_ONLY = "CARS_ONLY",
  HOTELS_ONLY = "HOTELS_ONLY",
  ACTIVITIES_ONLY = "ACTIVITIES_ONLY",

  // For traveler management page
  ALL = "ALL",
}

export const MINIMUM_DRIVER_AGE = 18;
